/**
 * Get the label for customer ID input based on category
 */
export const getCustomerIdLabel = (category) => {
  switch (category) {
    case 'airtime':
    case 'data':
      return 'Phone Number'
    case 'electricity':
      return 'Meter Number'
    case 'television':
      return 'Account/Device ID'
    default:
      return 'Customer ID'
  }
}

/**
 * Get the placeholder text for customer ID input
 */
export const getCustomerIdPlaceholder = (category) => {
  switch (category) {
    case 'airtime':
    case 'data':
      return 'Enter phone number (e.g., 08012345678)'
    case 'electricity':
      return 'Enter meter number'
    case 'television':
      return 'Enter account or device ID'
    default:
      return 'Enter customer ID'
  }
}

/**
 * Get validation rules for customer ID based on category
 */
export const getCustomerIdRules = (category) => {
  const baseRules = [
    {
      required: true,
      message: `Please enter ${getCustomerIdLabel(category).toLowerCase()}`
    }
  ]

  switch (category) {
    case 'airtime':
    case 'data':
      return [
        ...baseRules,
        {
          pattern: /^(\+234|0)[789]\d{9}$/,
          message:
            'Please enter a valid Nigerian phone number (e.g., 08012345678)'
        }
      ]
    case 'electricity':
      return [
        ...baseRules,
        {
          pattern: /^\d{11,12}$/,
          message: 'Meter number should be 11-12 digits'
        }
      ]
    case 'television':
      return [
        ...baseRules,
        {
          min: 3,
          message: 'Please enter a valid account/device ID'
        }
      ]
    default:
      return baseRules
  }
}

export const getAmountRules = () => {
  return [
    { required: true, message: 'Please enter amount' },
    {
      validator: (_, value) => {
        if (value === null || value === undefined || value === '') {
          return Promise.resolve()
        }
        const amount = typeof value === 'number' ? value : parseFloat(value)
        if (amount < 10) {
          return Promise.reject(new Error('Minimum amount is ₦10'))
        }
        if (amount > 1000000) {
          return Promise.reject(new Error('Maximum amount is ₦1,000,000'))
        }
        return Promise.resolve()
      }
    }
  ]
}

/**
 * Calculate transaction fee (2% with minimum of ₦10)
 */
export const calculateFee = (amount) => {
  return Math.max(amount * 0.02, 10)
}
